import { defineComponent as _defineComponent } from 'vue'
import { useLogin } from "@/composables/useLogin";
import LoginInterface from "@/components/LoginInterface.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginPage',
  setup(__props) {

const { loginUser } = useLogin()

return { __sfc: true,loginUser, LoginInterface }
}

})